// Split an array into consecutive sub-arrays of at most `size` items, in order.
// Used to cap the number of IDs serialised into a single GET query string so a
// large batch can't blow past a proxy's URL-length limit (~8KB).
export default function chunk<T>(items: readonly T[], size: number): T[][] {
  if (size < 1) {
    return [items.slice()];
  }
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}
